<div style="overflow: scroll; max-height: 405px" class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort id="reusableTable">
      <!-- checkbox column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [hidden]="disableCheckboxesColumn">
          <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" (change)="getRowData()" color="primary"> <b>Select All</b>
          </mat-checkbox>
        </th>
  
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [hidden]="disableCheckboxesColumn" (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
            (change)="getRowData()" color="primary">
            <!-- is always last -->
          </mat-checkbox>
        </td>
      </ng-container>
  
      <!-- edit column -->
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef [hidden]="disableEditColumn">
          <b>Edit</b>
        </th>
  
        <td mat-cell *matCellDef="let row">
          <a style="cursor: pointer;" (click)="editButton(row)">
            <mat-icon class="nc-icon-glyph ui-1_edit-78" style="margin: auto; transform: scale(2); padding-top: 5px; padding-left: 5px"></mat-icon>
          </a>
        </td>
      </ng-container>
  
      <!-- delete column -->
      <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef [hidden]="disableDeleteColumn">
            <b>Delete</b>
          </th>
    
          <td mat-cell *matCellDef="let row">
            <a style="cursor: pointer;" (click)="deleteButton(row)">
              <mat-icon class="nc-icon-glyph ui-1_simple-remove" style="margin: auto; transform: scale(2); padding-top: 5px; padding-left: 7px"></mat-icon>
            </a>
          </td>
        </ng-container>
  
        <!-- index column -->
      <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef [hidden]="disableIndexColumn">
            <b>Index</b>
          </th>
    
          <td mat-cell *matCellDef="let row; let i = index">
              {{ i + 1 }}
          </td>
        </ng-container>
  
      <!-- for every header in displayed columns, create a column and fill rows -->
      <!-- this runs if user disables checkboxes -->
      <ng-container>
        <ng-container *ngFor="let column of columns | slice:slices;" matColumnDef="{{column.columnDef}}">
          <th mat-header-cell *matHeaderCellDef mat-sort-header (click)="removeSelect()"><b>{{ column.header }}</b></th>
          <!-- <td mat-cell *matCellDef="let row" matTooltip="{{matTooltip}}"><a href="#" style="display: block">{{ column.cell(row) }}</a></td> -->
          <ng-container *ngIf="enableRowLinks === true; else elseTemplate">
            <td mat-cell *matCellDef="let row" matTooltip="{{matTooltip}}"><a href="#" style="display: block">{{
                column.cell(row) }}</a></td>
          </ng-container>
  
          <ng-template #elseTemplate>
            <td mat-cell *matCellDef="let row" matTooltip="{{matTooltip}}">{{ column.cell(row) }}</td>
          </ng-template>
        </ng-container>
      </ng-container>
  
      <!-- define displayedcolums and rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <ng-container *ngIf="enableSelectableRows === true; else noSelectTemplate">
        <tr style="height:30px" class="element-row" mat-row *matRowDef="let row; columns: displayedColumns; let rIndex = index;"
          (click)="toggleSelectedRow(rIndex, row)" [@selectRow]="selectedRowIndex === rIndex ? 'selected' : 'notSelected'"></tr>
           <!--[ngClass]="{'highlight': selectedRowIndex == rIndex}" [@selectRow]="toggleAnimationBool ? 'selected' : 'notSelected'"  (click)="toggleAnimation()"-->
      </ng-container>
  
      <!-- if selectable rows are enabled -->
      <ng-template #noSelectTemplate>
        <tr style="height:30px" class="element-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </ng-template>
  
      <!-- used for expandable rows -->
      <!-- <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"
      matRipple
      class="element-row"
      (click)="toggleRow(element)"></tr>
  
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isExpansionDetailRow"
          [@detailExpand]="row.element.show ? 'expanded' : 'collapsed'" style="overflow:hidden">
      </tr> -->
    </table>
  </div>
  <mat-paginator [pageSizeOptions]="[20, 10, 5]" showFirstLastButtons></mat-paginator>
  
  <!-- Old way of creating a table -->
  <!-- position column -->
  <!-- <ng-container matColumnDef="blnktSlsOrderCd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Corp</th>
      <td mat-cell *matCellDef="let element">{{ element.blnktSlsOrderCd }}</td>
    </ng-container> -->
  
  <!-- Name Column -->
  <!-- <ng-container matColumnDef="facilityCd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Facility</th>
      <td mat-cell *matCellDef="let element"> {{ element.facilityCd }} </td>
    </ng-container> -->
  
  <!-- Weight Column -->
  <!-- <ng-container matColumnDef="planTypeCd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Plan Type</th>
      <td mat-cell *matCellDef="let element"> {{element.si.planTypeCd}} </td>
    </ng-container> -->
  
  <!-- Symbol Column -->
  <!-- <ng-container matColumnDef="si.instructionsTxt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Instructions</th>
      <td mat-cell *matCellDef="let element"> {{element.si.instructionsTxt}} </td>
    </ng-container> -->
  
  <!-- Expanded Content Column - The detail row is made up of this one column -->
  <!-- <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let detail" colspan="5"> 
          The symbol for {{detail.element.name}} is {{detail.element.symbol}}
        </td>
      </ng-container> -->